module.exports = __webpack_public_path__ + "media/site_templates/www.fencingcolorbond.net.au/images/our_services_2-fa529f43ad7ee7ed81eb4acf4fc87715.jpg";